import { Logger } from "../../Logger";
import { axios } from "gather-common-including-video/dist/src/public/axios";
import { HttpV2Client } from "../../Globals";
import { HttpV2Paths } from "gather-http-common/dist/src/public/httpAPI";
import { isTest } from "gather-env-config/dist/src/public/envShared";
export const authenticateLiveKitSession = async (userId, spaceId, selfHost) => {
    Logger.log("[LK] acquiring token");
    const res = await fetchToken(userId, spaceId, selfHost);
    if (!res?.token || !res.serverURL) {
        throw Error("Could not retrieve livekit token or server url");
    }
    else {
        Logger.log("[LK] successfully acquired token");
    }
    return { token: res.token, serverURL: res.serverURL };
};
const fetchToken = async (userId, spaceId, selfHost) => isTest
    ? (await axios.get(`http://localhost:3099/livekit/token?userId=${userId}&spaceId=${spaceId}`))
        .data
    : await HttpV2Client.get(HttpV2Paths.LivekitToken, {
        params: { path: { space: spaceId }, query: { selfHost: String(selfHost) } },
        auth: true,
    });
//# sourceMappingURL=LivekitAuth.js.map